import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import API from "../../api"
const {testimonialsList,testimonialsAdd,testimonialsUpdate,testimonialsDelete,testimonialsStatus,testimonialsEdit}=API

const initialState = { 
    data:[],
    singleData:[],
    singleTestimonials:[],
    error: null, 
    loading:false,
    message:'',
    deleteLoad:false,
    editData:[]
}

const testimonialsSlice = createSlice({
    name: "testimonials",
    initialState,
    reducers: {
      setData(state,action){
          state.data=action.payload;
      },
      setLoading(state, action) {
          state.loading = action.payload;
        },
      setMessage(state,action){
          state.message=action.payload;
      },
      setError(state,action){
          state.error=action.payload;
    },
      setDeleteLoad(state,action){
          state.deleteLoad=action.payload
      },
      setAfterDeleteTestimonials(state,action){
          state.data=state.data.filter((item)=>item._id !== action.payload)
      },
      setTestimonialsAdd(state,action){
          state.data=[action.payload,...state.data]
      },
      setEditTestimonials(state,action){
          state.singleTestimonials=state.data.filter((item)=>item._id === action.payload)
      },
      setBlankSingleData(state,action){
        state.singleTestimonials=[]
      },
      setChnageStatus(state,action){
        state.singleData=state.data.filter((item)=>item._id == action.payload)
        state.singleData[0].status=state.singleData[0].status===1?0:state.singleData[0].status===0?1:''
      },
      setEditData(state,action){
        state.editData=action.payload
    }
    },
  });
  
  export const {setEditData, setChnageStatus, setLoading, setMessage,setError,setData,setDeleteLoad,setTestimonialsAdd,setAfterDeleteTestimonials,setEditTestimonials,setBlankSingleData} = testimonialsSlice.actions;
  export default testimonialsSlice.reducer;

  export const getTestimonialsData = (msg) => async (dispatch) => {
         dispatch(setLoading(true));
    try {
      const res= await testimonialsList()
      if (res.data.success) {
          dispatch(setData(res.data.data))
          dispatch(setLoading(false));
          dispatch(setMessage(res.data.message))
          if(msg==='msg'){

          }else{
            // message.success(res.data?.message);
          }
      } else {
          dispatch(setLoading(false));
          dispatch(setError(res.data.message));
      }
    } catch (e){
      dispatch(setLoading(false));
      dispatch(setError(e.message));
      message.error(e.message);
    }
  };
  export const testimonialsDataAdded=(data) => async (dispatch)=>{
    dispatch(setDeleteLoad(true));
    try{
      const res= await testimonialsAdd(data)
      if(res.data.success) {
         dispatch(setTestimonialsAdd(data))
         dispatch(setDeleteLoad(false))
         dispatch(setMessage(res.data.message))
         message.success(res.data?.message);
      } else {
        dispatch(setDeleteLoad(false));
        dispatch(setError(res.data.message));
        message.error(res.data.message);
    }
    } catch(e){
      dispatch(setDeleteLoad(false));
      dispatch(setError(e.response.data.message));
      message.error(e.response.data.message);
    }
}

export const sigleTestimonialsDataAction=(id) =>(dispatch)=>{
              dispatch(setEditTestimonials(id))
}
export const blankDataAction=() =>(dispatch)=>{
             dispatch(setBlankSingleData())
}  
export const testimonialsDataUpdate=(id,data) => async (dispatch)=>{
  dispatch(setDeleteLoad(true));
  try{
    const res= await testimonialsUpdate(id,data)
    if(res.data.success) {
       dispatch(setBlankSingleData())
       dispatch(setEditData())
       dispatch(setDeleteLoad(false))
       dispatch(setMessage(res.data.message))
       message.success(res.data?.message);
    } else {
      dispatch(setDeleteLoad(false));
      dispatch(setError(res.data.message));
      message.error(res.data.message);
  }
  } catch(e){
    dispatch(setDeleteLoad(false));
    dispatch(setError(e.response.data.message));
    message.error(e.response.data.message);
  }
}
export const testimonialsEditAction=(id) => async (dispatch)=>{
  try{
    const res= await testimonialsEdit(id)
    if(res.data.success) {
       dispatch(setEditData(res.data.data))
    } else {
      message.error(res.data.message);
  }
  } catch(e){
    message.error(e.response.data.message);
  }
}
export const editBlankData=() =>(dispatch)=>{
        dispatch(setEditData())
}
  export const testimonialsDataDelete=(id) => async (dispatch)=>{
          dispatch(setDeleteLoad(true));
          try{
            const res= await testimonialsDelete(id)
            if(res.data.success) {
               dispatch(setAfterDeleteTestimonials(id))
               dispatch(setDeleteLoad(false))
               dispatch(setMessage(res.data.message))
               message.success(res.data?.message);
            } else {
              dispatch(setDeleteLoad(false));
              dispatch(setError(res.data.message));
              message.error(res.data.message);
          }
          } catch(e){
            dispatch(setDeleteLoad(false));
            dispatch(setError(e.response.data.message));
            message.error(e.response.data.message);
          }
  }

  export const statusChangeAction = (id) => async (dispatch) => {
    dispatch(setDeleteLoad(true));
   try {
   const res= await testimonialsStatus(id)
    if (res.data.success) {
     dispatch(setChnageStatus(id))
     dispatch(setDeleteLoad(false));
     dispatch(setMessage(res.data.message))
     message.success(res.data?.message);
} else {
   dispatch(setDeleteLoad(false));
   dispatch(setError(res.data.message));
}
} catch (e){
dispatch(setDeleteLoad(false));
dispatch(setError(e.response.data.message));
message.error(e.response.data.message);
}
};